import { Typography } from '@mui/material'
import React from 'react'
import { InstallationWithoutAccess } from 'src/Libs/installations/models'
import { getInstallationWithoutAccessOwnerName } from 'src/Libs/installations/utils'

interface Props {
  installation: InstallationWithoutAccess
}

/**
 * Display owner name for installations without access.
 */
const InstallationWithoutAccessOwnerName: React.FC<Props> = ({ installation }) => {
  const ownerName = getInstallationWithoutAccessOwnerName(installation)
  return <Typography variant="body1">{ownerName}</Typography>
}

export default InstallationWithoutAccessOwnerName
